/** ч.770: «Депонування зарплати» — закриття платіжної відомості (невидане → 662). */
import { api } from './client';
import type { Page } from './catalogs';

export interface SalaryDepositItem {
  id?: string;
  line_number?: number;
  employee_id: string;
  amount: string;
  settlement_account_code?: string | null;
}

export interface SalaryDepositListItem {
  id: string;
  organization_id: string;
  document_number: string;
  document_date: string;
  payroll_payment_id: string | null;
  period_year: number | null;
  period_month: number | null;
  total_amount: string;
  posted: boolean;
  deletion_mark: boolean;
}

export interface SalaryDeposit extends SalaryDepositListItem {
  comment: string | null;
  posted_at: string | null;
  items: SalaryDepositItem[];
}

export interface SalaryDepositCreate {
  organization_id: string;
  document_number?: string | null;
  document_date: string;
  payroll_payment_id?: string | null;
  period_year?: number | null;
  period_month?: number | null;
  comment?: string | null;
  items: { employee_id: string; amount: string; settlement_account_code?: string | null }[];
}
export type SalaryDepositUpdate = Partial<Omit<SalaryDepositCreate, 'organization_id'>>;

export const salaryDeposits = {
  list: (params?: {
    organization_id?: string; period_year?: number; period_month?: number; period_from?: string; period_to?: string; posted?: boolean;
    sort_by?: string; sort_dir?: 'asc' | 'desc'; limit?: number; offset?: number;
  }) => api.get<Page<SalaryDepositListItem>>('/salary-deposits', { params }).then((r) => r.data),
  get: (id: string) => api.get<SalaryDeposit>(`/salary-deposits/${id}`).then((r) => r.data),
  create: (p: SalaryDepositCreate) => api.post<SalaryDeposit>('/salary-deposits', p).then((r) => r.data),
  update: (id: string, p: SalaryDepositUpdate) => api.patch<SalaryDeposit>(`/salary-deposits/${id}`, p).then((r) => r.data),
  remove: (id: string) => api.delete(`/salary-deposits/${id}`).then(() => undefined),
  post: (id: string) => api.post<SalaryDeposit>(`/salary-deposits/${id}/post`).then((r) => r.data),
  unpost: (id: string) => api.post<SalaryDeposit>(`/salary-deposits/${id}/unpost`).then((r) => r.data),
};

export interface CloseSheetResult {
  salary_deposit_id: string; document_number: string; total_amount: string; employees: number;
}
export const closePayrollSheet = (paymentId: string, employeeIds: string[], documentDate?: string) =>
  api.post<CloseSheetResult>(`/payroll-payments/${paymentId}/close-sheet`, {
    employee_ids: employeeIds, document_date: documentDate ?? null,
  }).then((r) => r.data);
